import templatableUtil from "@lib/liquid/templatableUtil";
import sharedConstants from "@lib/shared_constants";

import { isPersonalizedHttpUrl, isValidHttpUrl, tokenizeOnNonLiquidWhitespace } from "./smsLinkShorteningHelper";

/**
 * Finds URLs in a message body that exceed the link shortening length limit.
 *
 * Validates both:
 * - Static URLs (checks total length)
 * - Personalized URLs (checks static content length, excluding Liquid tags)
 *
 * @param body - The message body to check
 * @param linkShorteningEnabled - Whether link shortening is enabled
 * @returns Array of URLs that exceed the 4000 character limit
 */
export const findUrlsExceedingShorteningLimit = (body: string, linkShorteningEnabled: boolean): string[] => {
  if (!linkShorteningEnabled) {
    return [];
  }

  const tokens = tokenizeOnNonLiquidWhitespace(body.trim());

  // Check static URLs (total length)
  const staticUrls = tokens.filter(isValidHttpUrl);
  const longStaticUrls = staticUrls.filter(
    (url) => url.length > sharedConstants.SMS.LIMITS.MAX_URL_LENGTH_FOR_SHORTENING
  );

  // Check personalized URLs (static content length, excluding Liquid tags)
  const personalizedUrls = tokens.filter(isPersonalizedHttpUrl);
  const longPersonalizedUrls = personalizedUrls.filter((url) => {
    const staticContentLength = templatableUtil.lengthExcludingLiquid(url);
    return staticContentLength > sharedConstants.SMS.LIMITS.MAX_URL_LENGTH_FOR_SHORTENING;
  });

  return [...longStaticUrls, ...longPersonalizedUrls];
};
